import { IGetState, TCardId, TChecklistItemId } from '../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { fetchHandler } from '../../../../../util/fetchHandler';
import Util from '../../../../../util/util';
import { REST_CHECKLIST_ITEM } from '../../../../constants';
import { getRestHeadersPatch } from '../../../../helpers/getRestHeadersHelper';
import { IRestChecklistItem } from '../../../../../types/rest/IRestChecklistItem';

export const itemRestPatch = (
    cardId: TCardId,
    itemId: TChecklistItemId,
    item: IRestChecklistItem
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IRestChecklistItem>(
            Util.getApiUrl(REST_CHECKLIST_ITEM + itemId), {
                ...getRestHeadersPatch(),
                body: JSON.stringify(item)
            }
        );
    };
    return action;
};
